import React, { useState } from 'react'
import { schedulesServices } from '../../../../database/schedules.database'
import { FORM_SCHEDULE_STATUS, FORM_TYPES } from '../constants/constants.stores'
import { getUrlSave, uploadImage } from '../../imageUploader/ImageStorage'
import { useNavigation } from '@react-navigation/native'
import { useFormContext, useFormRefrigeratorContext } from '../context/form.context'
import { fetchAuthSession } from 'aws-amplify/auth'
import { request_save_form } from '../../../services/schedule.services'
import { FinishSheet } from '../ExecutionView'
import { useStoreContext } from '../context/store.context'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { captureAndSaveDataError, isValidDateString, isValidMongoId } from '../../../utils/functions.utils'

interface useFormViewI {
    store_id?: string
    form_id?: string
    schedule_id?: string
    checkin_id?: string
    reloadFormsData?: () => void
    hasFinishSheet?: boolean
    clearRegisterDatabaseLocal?: () => void
    title?: string
}

export const useFormView = ({
    form_id = null,
    schedule_id = null,
    store_id = null,
    checkin_id,
    reloadFormsData,
    hasFinishSheet,
    clearRegisterDatabaseLocal,
    title,
}: useFormViewI) => {
    // console.log('🚀 ~desde fov schedule_id:', schedule_id, checkin_id, store_id)
    const defaultScheduleId = schedule_id
    const defaultFormId = form_id
    const defaultStoreId = store_id
    const _INCIDENCE = true

    const navigation = useNavigation()
    const { formsContext, setFormsContext, setReloadChange, updateProgressForm, updateStatusForm, currentCheckin } = useFormContext()
    const { getFormRefrigerator, updateActveFormRefrigerator, form_refrigerators_main, forms_refrigerators } = useFormRefrigeratorContext()
    const { openBottomSheet, closeBottomSheet, isOpen } = useBottomSheet()
    const { setReloadFormsFn } = useStoreContext()

    const [isLoadingReload, setIsLoadingReload] = useState(false)
    const [buttonActive, setbuttonActive] = useState(false)
    const [reloadData, setReloadData] = useState(true)

    /**
     * @description logica para enviar formularios pendientes
     */
    const sendFormsPending = async () => {
        try {
            // traigo las answers en pendiente
            // const resFormsPending = await schedulesServices.getFormsAnswersByStatus(FORM_SCHEDULE_STATUS.PENDING_CONNECTION)
            //* trae registros con status pending y que la key checkout sea false
            const resFormsPending = await schedulesServices.getFormsAnswersByStatus2(
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE,
            )
            console.log('==============>>🚚 forms pendientes a enviar', resFormsPending.length)
            // console.log('==============>>🚚 forms pendientes a enviar', resFormsPending)
            await sendForms(resFormsPending)

            const resFormsPendingIncidence = await schedulesServices.getFormsAnswersByStatus2(
                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE,
                _INCIDENCE
            )

            console.log('==============>>🚚 forms incident pendientes a enviar', resFormsPendingIncidence.length)

            await sendForms(resFormsPendingIncidence)

        } catch (error) {
            console.error('2 sendFormsPending: ', error)
        }
    }

    const sendForms = async (formsPending) => {
        console.log('formsPending => ', formsPending.length)
        if (formsPending == null || formsPending == undefined || formsPending.length == 0) {
            console.log('no hay forms pendientes a enviar..')
            return 
        }

        if (formsPending && formsPending.length > 0) {
            // tengo forms pendientes entonces

            for (const formPending of formsPending) {
                try {
                    const form_id = formPending.form_id
                    const store_id = formPending.store_id
                    const schedule_id = formPending.schedule_id
                    const register_id = formPending._id
                    const name_form = formPending.name_form

                    let answers = JSON.parse(formPending.answers)
                    let status_send = 0
                    // console.log('formPending._id', formPending._id)
                    // console.log('formPending.status', formPending.status)
                    // console.log('formPending.status_send', formPending.status_send)
                    // console.log('formPending.name_form', formPending.name_form)

                    if (formPending.status_send === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) {
                        const responseSendForm = await sendForm(
                            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                            null,
                            schedule_id,
                            form_id,
                            store_id,
                            () => {},
                            register_id,
                        ) //este es el posible error
                        console.log('116 --- 🚀 ~ responseSendForm:', responseSendForm)
                        status_send = typeof responseSendForm === 'object' && responseSendForm?.send_status ? responseSendForm.send_status : (responseSendForm as number)

                        // console.log("75 -- 🚀 ~ sendFormsPending ~ status_send:", status_send)
                        if (!status_send) {
                            console.log('==============>>🚚 error al enviar form', form_id)
                            await schedulesServices.updateStatusFormAnswerSchedule(
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                schedule_id,
                                form_id,
                                store_id,
                                'error al enviar form PENDING_CONNECTION',
                                register_id,
                            )
                            //agrego la actualizacion de status en la nueva key status_send
                            await schedulesServices.updateStatusSendForm(
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                schedule_id,
                                form_id,
                                store_id,
                                'error al enviar form PENDING_CONNECTION',
                                register_id,
                            )
                        } else {
                            console.log('==============>>🚚 envio el form', form_id, register_id, name_form)
                            await schedulesServices.updateStatusFormAnswerSchedule(
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                schedule_id,
                                form_id,
                                store_id,
                                'PENDING_CONNECTION',
                                register_id,
                            )
                            //agrego la actualizacion de status en la nueva key status_send
                            await schedulesServices.updateStatusSendForm(
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                schedule_id,
                                form_id,
                                store_id,
                                'error al enviar form PENDING_CONNECTION',
                                register_id,
                            )
                        }
                    }

                } catch (error) {
                    console.error('122 sendFormsPending: ', error)
                }
            }
        }
    }

    const isAllQuestionsMandatoryFalse = (questions: any[], type_form = null): boolean => {
        try {
            if (type_form && type_form.type == FORM_TYPES.FORM_REDIRECT) {
                return true
            } else {
                return questions.every((question) => question.mandatory === false)
            }
        } catch (error) {
            console.error('164 -- isAllQuestionsMandatoryFalse: ', error)
            return false
        }
    }

    const sendForm = async (
        status: number,
        actionButonSend?: () => void,
        schedule_id = defaultScheduleId,
        form_id = defaultFormId,
        store_id = defaultStoreId,
        navigate = navigateGoBack,
        register_id = null,
    ) => {
        // console.log('🚀 ~desde actionButonSend :', actionButonSend)
        console.log(`schedule_id = ${schedule_id}, form_id = ${form_id}, store_id = ${store_id}, register_id = ${register_id}`)
        try {
            let send_status = 0
            let data_alias = null
            const {
                fqa_id,
                answers,
                date_init,
                date_finish,
                progress_questions_yes_na,
                heladera,
                create_refrigerator,
                type_form,
                form_id_father,
                scoreObtained,
                repeat,
                questions,
                name_form,
                checkin_id
            } = await schedulesServices.getFormsAnswers(schedule_id, form_id, store_id, register_id)

            console.log('====================================>>> Total respuestas, ', form_id, answers.length, type_form)
            console.log('====================================>>> checkin_id, ', checkin_id)

            const allQuestionMandatoryFalse = isAllQuestionsMandatoryFalse(questions, type_form)

            if (answers.length == 0 && !allQuestionMandatoryFalse) {

                const resFormsPending = await schedulesServices.getFormsAnswersByStatus2(
                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE,
                )
                const errorCap = {
                    answers: answers,
                    answersLeng: answers.length,
                    form_id: form_id,
                    schedule_id: schedule_id,
                    store_id: store_id,
                    type_form: type_form,
                    name_form: name_form,
                    resFormsPending: resFormsPending
                }
                const dataCapture = {
                    log: JSON.stringify(errorCap),
                    date: new Date().toISOString(),
                    end: 'sendForm',
                    // additional: JSON.stringify(additional)
                }

                await captureAndSaveDataError(dataCapture)

                return send_status
            }

            const newFormsContext = updateProgressForm(formsContext, schedule_id, form_id, store_id, progress_questions_yes_na)
            if (heladera !== 1 && newFormsContext) {
                await schedulesServices.updateStatusFormAnswerSchedule(status, schedule_id, form_id, store_id, null, fqa_id)
                const index = newFormsContext.findIndex((form) => form._id.toString() === form_id.toString())

                if (index !== -1) {
                    const updatedForms = [...newFormsContext]
                    updatedForms[index] = {
                        ...updatedForms[index],
                        status: status, // Cambia el status aquí
                    }

                    setFormsContext(updatedForms)
                    setReloadChange()
                }
            }

            if (type_form && type_form['type'] && type_form['type'] !== FORM_TYPES.FORM_MODERACION) {
                // Todo: @fixme @lau - revisar esta funcion
                /* 
                    la funcion de adentro deberia solamente subir la imagen a s3, no deberia hacer nada mas
                    la funcion que esta puesta ahora es un get url de la imagen que se usa en el componente foto cuando se tiene conexion
                    hay que separar esa logica para evitar errores. solamente titne que subir ya que el back se encarga de concatenar la url
                */
                await verifyAnswersImage(answers)
            }

            let obj_json_raw = {
                answers: answers,
                date_finish: isValidDateString(date_finish) ? date_finish : date_init,
                date_init: date_init,
                id_activity: form_id,
                status: 0,
                progress: progress_questions_yes_na,
                score: scoreObtained,
                heladera: heladera,
                create_refrigerator: create_refrigerator,
                input_type: type_form ? type_form['type'] : null,
                refrigerator_id: '',
                store_id: store_id,
            }

            if (heladera === 1) {
                const { form } = getFormRefrigerator(forms_refrigerators, form_id)

                if (form && form.refrigerator_id) {
                    obj_json_raw.refrigerator_id = form.refrigerator_id
                }
            }

            if (form_id_father && form_id_father !== '') {
                obj_json_raw.id_activity = form_id_father
            }

            let json_raw = [obj_json_raw]

            const session = await fetchAuthSession()
            const authToken = session.tokens?.accessToken?.toString() || ""

            let dif_utc = -new Date().getTimezoneOffset() / 60

            let data_checkin_id

            // console.log('checkin_id => ', checkin_id)
            // console.log('store_id => ', store_id)

            if (isValidMongoId(checkin_id)) {
                // si existe el checkin_id lo uso
                console.log('🚀🚀🚀🚀🚀🚀🚀 ~ checkin_id existe, lo uso => ', checkin_id)
                data_checkin_id = checkin_id

            } else {
                // if ((checkin_id == null || checkin_id == undefined) && store_id) {
                if (!isValidMongoId(checkin_id) && store_id) { // no existe y tengo store_id
                    // si no existe lo busco en local
                    console.log('🚀🚀🚀🚀🚀🚀🚀 ~ checkin_id no existe, busco en local')
    
                    const checkin = await schedulesServices.get_checkin(store_id, schedule_id)
                    console.log('🚀 ~ checkin:', checkin)
                    if (checkin && checkin.length > 0) {
                        const index = checkin.length - 1
                        data_checkin_id = checkin[index].checkin_id
                    } else {
                        const checkin_adv = await schedulesServices.getStoreScheduleAdvances(schedule_id, store_id)
                        console.log('🚀 ~ checkin_adv:', checkin_adv)
                        if (checkin_adv && checkin_adv.checkin_id) {
                            data_checkin_id = checkin_adv.checkin_id
                        } else {
                            data_checkin_id = currentCheckin
                        }
                    }
                } else {
                    data_checkin_id = checkin_id ?? currentCheckin
                }

            }


            console.log(data_checkin_id, '99999999999999999999999 datos a enviar', store_id, checkin_id)

            const validateStoreIdTypeIncidence = store_id && store_id != '' && obj_json_raw['input_type'] == FORM_TYPES.FORM_INCIDENCE
            // console.log('validateStoreIdTypeIncidence => ', validateStoreIdTypeIncidence)
            if (
                !store_id || store_id == '' || 
                ((store_id && store_id != '' && data_checkin_id && data_checkin_id != '') || validateStoreIdTypeIncidence)
            ) {

                const check_in = validateStoreIdTypeIncidence ? store_id : (store_id && store_id != '') ? data_checkin_id : null
                console.log('check_in a enviar en sendForm ===================> ', check_in)
                const data = {
                    authToken: authToken,
                    body: {
                        form: JSON.stringify(json_raw),
                        process_now: true,
                        date: new Date().toISOString(),
                        schedule_id: schedule_id,
                        checkin_id: check_in,
                        dif_utc: dif_utc.toString(),
                    },
                }
                const res = await request_save_form(data)
                console.log('request_save_form => response => :', res)
                if (res && res.status && res.response.status == 1) {
                    send_status = res.status
                    data_alias = res?.response?.single?.data_alias

                    if (heladera == 1) {
                        const remplaceAnswers = true
                        const clearAnswers = true
                        // elimino las respuestas del form
                        await schedulesServices.updateFormAnswerSchedule(null, schedule_id, form_id, store_id, remplaceAnswers, clearAnswers)

                        const { form, formQuestions } = getFormRefrigerator(forms_refrigerators, form_id)

                        if (form && formQuestions && formQuestions.length > 0) {
                            const active = false
                            updateActveFormRefrigerator(form_refrigerators_main, form_id_father, form.question_id, active)
                        }

                        if (create_refrigerator === 1) {
                            setReloadFormsFn()
                            reloadFormsData()
                        }
                    }
                    if (form_id && !store_id) {
                        //actualizacion en agenda
                        if (hasFinishSheet) {
                            openFinishSheet()
                        }

                        if (clearRegisterDatabaseLocal) {
                            setIsLoadingReload(true)
                            clearRegisterDatabaseLocal()
                            setbuttonActive(false)
                            setReloadData(!reloadData)
                            return send_status
                        }

                        const today = new Date().toISOString()

                        if (heladera !== 1) {
                            let score_form = scoreObtained ? scoreObtained.toString() : '0'
                            await schedulesServices
                                .upsertFormStatus(schedule_id, form_id, 1, new Date().toISOString(), progress_questions_yes_na, score_form)
                                // .then(() => navigation.goBack())
                                .then(() => {
                                    if (actionButonSend != undefined) {
                                        actionButonSend()
                                    } else {
                                        navigate()
                                    }
                                })
                                .catch((error) => {
                                    console.error('Error actualizando la agenda:', error)
                                })
                        } else {
                            // navigation.goBack()
                            navigate()
                        }
                    } else {
                        // navigation.goBack()
                        if (repeat && repeat == 1) {
                            // updateo las answers a [] if (type_form.type == 43) {

                            console.log('297 --- entre aca ?: fqa_id', fqa_id)
                            await schedulesServices.clearFqaAnswersById(fqa_id)
                        }
                        if (type_form.type == FORM_TYPES.FORM_REDIRECT) {
                            console.log('type ext')
                        } else {
                            navigate()
                        }
                    }
                }
            }
            return {
                send_status,
                data_alias
            }
        } catch (error) {
            console.error(error)
            const dataCapture = {
                    log: JSON.stringify(error),
                    date: new Date().toISOString(),
                    end: 'sendForm catch',
                    // additional: JSON.stringify(additional)
                }

                await captureAndSaveDataError(dataCapture)

            throw new Error(error)
        }
    }

    /**
     * @description recorre las imagenes y las sube a s3
     * @param answers []
     */
    const verifyAnswersImage = async (answers) => {
        try {
            for (const ans of answers) {
                if (ans && ans.pickerResult_uri && ans.pickerResult_uri !== '') {
                    // const { imageUrlDB } = await getUrlSave(ans.media, ans.pickerResult_uri)
                    await uploadImage(ans.media, ans.pickerResult_uri)
                }
            }

            // await schedulesServices.updateStatusFormAnswerSchedule(FORM_SCHEDULE_STATUS.COMPLETED, schedule_id, form_id, store_id)

            // const index = formsContext.findIndex((form) => form._id.toString() === form_id.toString())

            // if (index !== -1) {
            //     const updatedForms = [...formsContext]
            //     updatedForms[index] = {
            //         ...updatedForms[index],
            //         status: FORM_SCHEDULE_STATUS.COMPLETED, // Cambia el status aquí
            //     }

            //     // console.log('264 ---- verifyAnswersImage - updatedForms[index]: ', updatedForms[index])
            //     setFormsContext(updatedForms)
            //     setReloadChange()
            // }
        } catch (error) {
            console.error('verifyAnswersImage: ', error)
        }
    }

    const openFinishSheet = () => {
        openBottomSheet(<FinishSheet closeBottomSheet={closeBottomSheet} title={title ?? ''} />)
    }

    const navigateGoBack = () => {
        navigation.goBack()
    }

    const updateStatusContext = (contextArray) => {
        const index = contextArray.findIndex((form) => form._id.toString() === form_id.toString())

        if (index !== -1) {
            const updatedForms = [...contextArray]
            updatedForms[index] = {
                ...updatedForms[index],
                status: status, // Cambia el status aquí
            }

            setFormsContext(updatedForms)
            setReloadChange()
        }
    }

    return {
        isOpen,
        sendFormsPending,
        sendForm,
        reloadData,
        isLoadingReload,
        openBottomSheet,
        closeBottomSheet,
        setIsLoadingReload,
        setbuttonActive,
        buttonActive,
    }
}
